import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FormErrorMessage } from "@avenue-8/sidekick-ui";
import { Controller, useFormContext } from "react-hook-form";
import { FindListingsFiltersFormSchema } from "@cma/chat-widgets/find-listings-search/helpers/property-search-filters-form-helpers";
import { PropertyStatusItemDto } from "@shared/apis/sidekick/generated";
import { useCallback } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type Props = {
  propertyStatuses: PropertyStatusItemDto[];
};

export const PropertyStatusField = (props: Props) => {
  const { propertyStatuses } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext<FindListingsFiltersFormSchema>();

  const renderSelectedPropertyStatus = useCallback(
    (selected: string[]) => {
      if (!selected || selected.length === 0) return "";

      const selectedLabels = selected
        .map((value) => {
          const status = propertyStatuses.find((s) => s.value === value);
          return status?.label || value;
        })
        .filter(Boolean);

      return selectedLabels.join(", ");
    },
    [propertyStatuses],
  );

  const handleChange = (
    event: SelectChangeEvent<string[]>,
    onChange: (value: string[]) => void,
  ) => {
    const value = event.target.value;
    onChange(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="property-status-label">Property Status</InputLabel>
      <Controller
        name="propertyStatus"
        control={control}
        render={({ field }) => (
          <Select
            labelId="property-status-label"
            id="propertyStatus"
            multiple
            label="Property Status"
            value={field.value || []}
            onChange={(event) => handleChange(event, field.onChange)}
            renderValue={renderSelectedPropertyStatus}
            MenuProps={MenuProps}
          >
            {propertyStatuses.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                <Checkbox
                  checked={(field.value || []).includes(status.value)}
                />
                <ListItemText primary={status.label} />
              </MenuItem>
            ))}
          </Select>
        )}
      />
      <FormErrorMessage>
        {errors.propertyStatus?.message ?? " "}
      </FormErrorMessage>
    </FormControl>
  );
};
